/* TooltipRow.tsx generated by @compiled/babel-plugin v0.28.8 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _14 = "._vwz41q5e{line-height:1.5em}";
const _13 = "._slp31hna{word-wrap:break-word}";
const _12 = "._k48p1nn1{font-weight:400}";
const _11 = "._1wybdlk8{font-size:14px}";
const _10 = "._syaz13nv{color:var(--ds-text-subtlest,grey)}";
const _9 = "._ect41wi2{font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif}";
const _8 = "._1e0c1txw{display:flex}";
const _7 = "._zulpftgi{gap:8px}";
const _6 = "._1bah1y6m{justify-content:flex-start}";
const _5 = "._u5f3ftgi{padding-right:8px}";
const _4 = "._1e0c116y{display:inline-flex}";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1bah1yb4{justify-content:space-between}";
const _ = "._1wpz1fhb{align-self:stretch}";
const outerDivCss = null;
const innerDivCss = null;
const colorItemCss = null;
const labelItemCss = null;
const valueItemCss = null;
export function TooltipRow(_ref) {
  let {
    color,
    label,
    value
  } = _ref;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_1wpz1fhb _1bah1yb4 _4cvr1h6o _1e0c116y"]),
      children: /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_5, _6, _3, _7, _8]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_u5f3ftgi _1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw"]),
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_6, _3, _7, _8]
            }), /*#__PURE__*/_jsx("div", {
              className: ax(["_1bah1y6m _4cvr1h6o _zulpftgi _1e0c1txw"]),
              children: /*#__PURE__*/_jsx("svg", {
                style: {
                  width: 12,
                  height: 12,
                  borderRadius: 2
                },
                children: /*#__PURE__*/_jsx("rect", {
                  width: "100%",
                  height: "100%",
                  fill: color
                })
              })
            })]
          }), /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_9, _10, _11, _12, _13]
            }), /*#__PURE__*/_jsx("div", {
              className: ax(["_ect41wi2 _syaz13nv _1wybdlk8 _k48p1nn1 _slp31hna"]),
              children: label
            })]
          }), /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_9, _10, _11, _12, _14, _13]
            }), /*#__PURE__*/_jsx("div", {
              className: ax(["_ect41wi2 _syaz13nv _1wybdlk8 _k48p1nn1 _vwz41q5e _slp31hna"]),
              children: value
            })]
          })]
        })]
      })
    })]
  });
}